export function CpfValidator(valor) {
    if (!valor) return { valido: true };

    const cpf = valor.replace(/\D/g, '');
    const cpfLength = 11;
    const cpfDigitLength = 2;

    // Tamanho inválido
    if (cpf.length !== cpfLength) {
        return { valido: false, reason: 'different sizes' };
    }

    // Todos os dígitos iguais
    if (/^([0-9])\1*$/.test(cpf)) {
        return { valido: false, reason: 'same number' };
    }

    let digitos = '';

    for (let ind = cpfDigitLength; ind >= 1; ind--) {
        const numerosCpf = cpf
            .split('')
            .reverse()
            .slice(ind);

        let digito = numerosCpf
            .map((numero, i) => numero * (i + cpfDigitLength))
            .reduce((total, atual) => total + atual, 0);

        digito = digito % cpfLength;
        digito = digito < cpfDigitLength ? 0 : cpfLength - digito;

        digitos += digito;
    }

    let cpfCalculado = cpf
        .split('')
        .reverse()
        .slice(cpfDigitLength)
        .reverse()
        .join('');

    cpfCalculado += digitos;

    if (cpfCalculado !== cpf) {
        return { valido: false, reason: 'invalid digit' };
    }

    return { valido: true };
}
